var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownChangeUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9496 17.1376C19.8617 16.7152 19.4481 16.4441 19.0255 16.532C18.6031 16.6199 18.332 17.0337 18.42 17.4561C18.4706 17.6994 18.4103 17.9487 18.2545 18.1404C18.1643 18.2514 17.963 18.4375 17.6295 18.4375H2.37117C2.03766 18.4375 1.83645 18.2513 1.74621 18.1404C1.59039 17.9488 1.53008 17.6994 1.58074 17.4561C2.39152 13.5617 5.82648 10.717 9.79324 10.621C9.86195 10.6237 9.93098 10.625 10.0004 10.625C10.07 10.625 10.1393 10.6236 10.2082 10.621C13.0025 10.688 15.5851 12.1033 17.1491 14.4358C17.3894 14.7942 17.8747 14.8899 18.2331 14.6496C18.5915 14.4094 18.6872 13.9241 18.4469 13.5657C17.165 11.6538 15.3036 10.2636 13.1811 9.56504C14.4745 8.59516 15.3129 7.04988 15.3129 5.3125C15.3129 2.3832 12.9297 0 10.0004 0C7.07102 0 4.68785 2.3832 4.68785 5.3125C4.68785 7.05094 5.52723 8.59703 6.82195 9.56684C5.6357 9.95738 4.52262 10.5651 3.5484 11.3664C1.76199 12.8358 0.519922 14.8854 0.0510543 17.1376C-0.0958988 17.8433 0.0801559 18.5682 0.533984 19.1262C0.985586 19.6815 1.65523 20 2.37117 20H17.6295C18.3455 20 19.0151 19.6815 19.4667 19.1262C19.9206 18.5682 20.0966 17.8433 19.9496 17.1376ZM6.25035 5.3125C6.25035 3.24473 7.93258 1.5625 10.0004 1.5625C12.0681 1.5625 13.7504 3.24473 13.7504 5.3125C13.7504 7.3166 12.1701 8.95856 10.1902 9.05773C10.127 9.05656 10.0637 9.05598 10.0004 9.05598C9.93731 9.05598 9.87426 9.0566 9.81129 9.05777C7.83102 8.95898 6.25035 7.31687 6.25035 5.3125Z",
    fill: "#364863"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownChangeUser);
export default __webpack_public_path__ + "static/media/dropdown-change-user.11a0d0c11fccbb2407a4eb76436447d6.svg";
export { ForwardRef as ReactComponent };